<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import WhatsappCatalogsManager from './WhatsappCatalogsManager.vue';

const route = useRoute();
const { t } = useI18n();

const initialInboxId = computed(() => String(route.query.inbox_id || ''));

const steps = computed(() => [
  {
    icon: 'i-hugeicons-store-add-01',
    title: t('WHATSAPP_CATALOGS.PAGE.STEP_CREATE_TITLE'),
    description: t('WHATSAPP_CATALOGS.PAGE.STEP_CREATE_DESCRIPTION'),
  },
  {
    icon: 'i-hugeicons-package',
    title: t('WHATSAPP_CATALOGS.PAGE.STEP_PRODUCTS_TITLE'),
    description: t('WHATSAPP_CATALOGS.PAGE.STEP_PRODUCTS_DESCRIPTION'),
  },
  {
    icon: 'i-hugeicons-shopping-cart-01',
    title: t('WHATSAPP_CATALOGS.PAGE.STEP_USE_TITLE'),
    description: t('WHATSAPP_CATALOGS.PAGE.STEP_USE_DESCRIPTION'),
  },
]);
</script>

<template>
  <main class="h-full min-h-0 w-full overflow-y-auto bg-n-surface-1">
    <div
      class="mx-auto flex w-full max-w-7xl flex-col gap-6 px-4 py-6 pb-24 sm:px-6 sm:py-8"
    >
      <header class="flex items-start gap-4">
        <span
          class="grid size-12 shrink-0 place-items-center rounded-xl bg-n-teal-3 text-n-teal-11"
          aria-hidden="true"
        >
          <span class="i-hugeicons-store-01 size-6" />
        </span>
        <div class="min-w-0">
          <p
            class="mb-1 text-xs font-semibold uppercase tracking-wide text-n-brand"
          >
            {{ t('WHATSAPP_CATALOGS.PAGE.EYEBROW') }}
          </p>
          <h1 class="mb-2 text-2xl font-semibold text-n-slate-12">
            {{ t('WHATSAPP_CATALOGS.TITLE') }}
          </h1>
          <p class="mb-0 max-w-3xl text-sm text-n-slate-11">
            {{ t('WHATSAPP_CATALOGS.PAGE.DESCRIPTION') }}
          </p>
        </div>
      </header>

      <ol
        class="m-0 grid list-none gap-3 p-0 md:grid-cols-3"
        :aria-label="t('WHATSAPP_CATALOGS.PAGE.STEPS_LABEL')"
      >
        <li
          v-for="(step, index) in steps"
          :key="step.title"
          class="flex items-start gap-3 rounded-xl border border-n-weak bg-n-solid-1 p-4"
        >
          <span
            class="grid size-9 shrink-0 place-items-center rounded-lg bg-n-alpha-2 text-n-slate-12"
            aria-hidden="true"
          >
            <span class="size-4" :class="step.icon" />
          </span>
          <div class="min-w-0">
            <p class="mb-1 text-sm font-semibold text-n-slate-12">
              {{ index + 1 }}. {{ step.title }}
            </p>
            <p class="mb-0 text-xs leading-5 text-n-slate-11">
              {{ step.description }}
            </p>
          </div>
        </li>
      </ol>

      <WhatsappCatalogsManager :initial-inbox-id="initialInboxId" />
    </div>
  </main>
</template>
